import React, { Component } from "react";
import { Form } from "react-bootstrap";

import DatePicker from "react-datepicker";

export default class SearchComponent extends Component {
  state = {
    departureDate: "",
    returnDate: ""
  };

  departurehandleChange = date => {
    this.setState({
      departureDate: date
    });
  };

  returnhandleChange = date => {
    this.setState({
      returnDate: date
    });
  };

  render() {
    return (
      <React.Fragment>
        <ul className="select-list">
          <li>
            <Form.Check
              custom
              type="checkbox"
              id={`custom-checkbox-1`}
              label={`Oneway Trip`}
            />
          </li>
          <li>
            <Form.Check
              custom
              type="checkbox"
              id={`custom-checkbox-2`}
              label={`Round Trip`}
            />
          </li>
          <li>
            <Form.Check
              custom
              type="checkbox"
              id={`custom-checkbox-3`}
              label={`Multicity`}
            />
          </li>
        </ul>
        <div className="trip-search-table table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th scope="col">From</th>
                <th scope="col" style={{ paddingLeft: 30 }}>
                  To
                </th>
                <th scope="col">Departure</th>
                <th scope="col">Return</th>
                <th scope="col">Passenger</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <select className="custom-select">
                    <option value="0">Flying from Airport</option>
                    <option value="1">Dhaka</option>
                    <option value="2">Chottogram</option>
                    <option value="3">Barishal</option>
                    <option value="4">Khulna</option>
                    <option value="5">Sylhet</option>
                    <option value="6">Cox's bazar</option>
                    <option value="7">Rajshahi</option>
                  </select>
                </td>
                <td style={{ paddingLeft: 30 }}>
                  <select className="custom-select">
                    <option value="0">Flying from Airport</option>
                    <option value="1">Dhaka</option>
                    <option value="2">Chottogram</option>
                    <option value="3">Barishal</option>
                    <option value="4">Khulna</option>
                    <option value="5">Sylhet</option>
                    <option value="6">Cox's bazar</option>
                    <option value="7">Rajshahi</option>
                  </select>
                </td>
                <td className="date-picker">
                  <DatePicker
                    placeholderText="Select Date"
                    selected={this.state.departureDate}
                    onChange={this.departurehandleChange}
                  />
                </td>
                <td className="date-picker">
                  <DatePicker
                    placeholderText="Select Date"
                    selected={this.state.returnDate}
                    onChange={this.returnhandleChange}
                  />
                </td>
                <td>
                  <select className="custom-select">
                    <option value="0">Select Passenger</option>
                    <option value="1">1 Passenger</option>
                    <option value="2">2 Passenger</option>
                    <option value="3">3 Passenger</option>
                  </select>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <a href="#" className="refresh-btn">
          <i className="fa fa-refresh"></i>
        </a>
      </React.Fragment>
    );
  }
}
